import { FETCH_DATA_REQUEST, DISPLAY_ERROR_MESSAGE, RESET_MODEL_AND_ERROR_FLAGS,
    FETCH_REMARK_OPTIONS, SET_SUBMIT_SUCCESS, SET_LOADING_FALSE, FETCH_DATE_CONFIG } from './actionTypes';

export const calendarchangeRequestReducer = (state, action) => {
    switch(action.type) {
        case FETCH_DATE_CONFIG : 
            return {
                ...state,
                sessionTimeoutLimit: action.payload.sessionTimeoutLimit,
                idleTimeoutLimit: action.payload.idleTimeoutLimit
            }
        case FETCH_DATA_REQUEST : 
            return {
                ...state,
                isError: action.payload.isError,
                showModel: false,
                modelHeaderTitle: "",
                errorMessage: action.payload.errorMessage,
                isLoading: true
            } 
        case FETCH_REMARK_OPTIONS : 
            return { 
                ...state, 
                remarksOptions: action.payload.remarksOptions,
                isLoading: false,
                isError: false
            };     
        case DISPLAY_ERROR_MESSAGE : 
            return {
                ...state,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,               
                isSuccessfullySaved: false,
                isLoading: false
            }  
        case RESET_MODEL_AND_ERROR_FLAGS :  
            return {
                ...state,
                isError: false, 
                errorMessage: "", 
                showModel: false,
                modelHeaderTitle: "",
                isLoading: false                                         
            }
        case SET_SUBMIT_SUCCESS : 
            return {
                ...state,
                isError: false, 
                showModel: true,
                modelHeaderTitle: action.payload.modelHeaderTitle,               
                isSuccessfullySaved: true,
                isLoading: false                                      
            } 
        case SET_LOADING_FALSE:
            return {
                ...state,
                isLoading: action.payload.isLoading                            
            } 
        default : 
            return state;   
    }
}
